module.exports = __webpack_public_path__ + "4ab65a1dd6b53b4fb0caab1ce3b9b67c.pdf";